import Events from "./Events";

export const Consent = {
  DENIED: 'denied',
  GRANTED: 'granted'
}

class GoogleTags {
  static GTM_ID = 'GTM-TR28W47';
  static AW_ID = null;
  static LOCAL_STORAGE_KEY = 'COOKS_DOORS_GTAG_CONSENT';
  static IDLE_TIMER = 5000;
  static timeout;
  static initialised = false;
  static TAGS = [
    "analytics_storage",
    "ad_storage",
    "ad_user_data",
    "ad_personalization"
  ];

  static HAS_RESET = false;

  static setListeners() {
    document.addEventListener(Events.SCROLL, GoogleTags.eventHandler);
    document.addEventListener(Events.MOUSE_MOVE, GoogleTags.eventHandler);
    document.addEventListener('touchstart', GoogleTags.eventHandler, { passive: true });

    GoogleTags.timeout = setTimeout(() => {
      GoogleTags.initGTM();
    }, GoogleTags.IDLE_TIMER);
  }

  static eventHandler(e) {
    clearTimeout(GoogleTags.timeout);
    GoogleTags.initGTM()
    e.currentTarget.removeEventListener(e.type, GoogleTags.eventHandler);
  }

  static initGTM() {
    if (GoogleTags.initialised) return false;
    GoogleTags.initialised = true;

    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.async = true;
    scriptTag.addEventListener(Events.LOAD, GoogleTags.sendPageView);
    scriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${GoogleTags.GTM_ID}`;

    document.head.appendChild(scriptTag);
  }

  static gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  static sendPageView() {
    window.dataLayer = window.dataLayer || [];

    const storage = localStorage.getItem(GoogleTags.LOCAL_STORAGE_KEY);
    const localData = storage ? JSON.parse(storage) : null;
    const defaultConsent = {};

    for (const tag of GoogleTags.TAGS) {
      if (localData && !GoogleTags.HAS_RESET) {
        Object.keys(localData).forEach(localTag => {
          if (localTag === tag) defaultConsent[tag] = localData[localTag];
        });
        continue;
      }

      defaultConsent[tag] = Consent.DENIED;
    }

    GoogleTags.gtag('consent', 'default', defaultConsent);
    localStorage.setItem(GoogleTags.LOCAL_STORAGE_KEY, JSON.stringify(defaultConsent));

    window.dataLayer.push({
      'event': 'default_consent'
    });

    window.dataLayer.push({
      'gtm.start': (new Date()).getTime(),
      event: 'gtm.js',
    });
  }

  static denyConsent(tagName) {
    GoogleTags.gtag('consent', 'update', {
      [tagName]: Consent.DENIED
    });

    const storage = localStorage.getItem(GoogleTags.LOCAL_STORAGE_KEY);
    const localData = storage ? JSON.parse(storage) : null;

    localStorage.setItem(
      GoogleTags.LOCAL_STORAGE_KEY,
      JSON.stringify({
        ... localData,
        [tagName]: Consent.DENIED
      }));
  }

  static grantConsent(tagName) {
    GoogleTags.gtag('consent', 'update', {
      [tagName]: Consent.GRANTED,
    });

    const storage = localStorage.getItem(GoogleTags.LOCAL_STORAGE_KEY);
    const localData = storage ? JSON.parse(storage) : null;

    localStorage.setItem(
      GoogleTags.LOCAL_STORAGE_KEY,
      JSON.stringify({
        ... localData,
        [tagName]: Consent.GRANTED
      }));
  }


  static consentAll() {
    GoogleTags.TAGS.forEach(tag => {
      GoogleTags.grantConsent(tag);
    });

    const localData = {};

    for (const tag of GoogleTags.TAGS) {
      localData[tag] = Consent.GRANTED;
    }

    localStorage.setItem(GoogleTags.LOCAL_STORAGE_KEY, JSON.stringify(localData));
  }

  static resetConsent() {
    GoogleTags.HAS_RESET = true;
  }

  static setPromptSeen() {
    // Method to mark that the cookie prompt has been seen
    // This can be used for analytics or tracking purposes
    console.log('Cookie prompt has been seen by user');
  }
}

export default GoogleTags;
